<template >
  <v-container fluid>
    <v-card class="mx-auto" max-width="344">
      <v-card-title>{{ name }}</v-card-title>

      <v-card-subtitle>
        <v-form
          ref="form"
          @submit.stop.prevent="checkForm"
          class="text-center"
          method="post"
        >
          <!-- ACCOUNT (RIGHT-CONTAINER) -->
          <v-text-field
            v-model="username"
            label="Username"
            name="username"
            :rules="[data.rules.userrequired]"
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            name="password"
            :rules="[data.rules.passwordrequired]"
          ></v-text-field>
          <v-alert v-for="e in errors" :key="e" dense outlined type="error"
            >{{ e }}
          </v-alert>
          <v-card-actions>
            <v-btn
              color="primary"
              class="mr-4"
              @submit="checkForm"
              type="submit"
              >SIGN IN</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
import { HTTP, BASE_URL } from "../../lib/http.common";
import { Encrypt, Decrypt } from "../../lib/encryption";
import Aes from "../../lib/aes";
export default {
  data() {
    return {
      name: "Login",
      data: {
        rules: {
          userrequired: function (value) {
            return !!value || "Username is equired.";
          },
          passwordrequired: function (value) {
            return !!value || "Password name is equired.";
          },
        },
      },
      error: false,
      errors: [],

      username: "",
      password: "",

      user: null,
    };
  },
  computed: {},
  components: {},
  methods: {
    checkForm() {
      this.$refs.form.validate();
      if (this.username && this.password) {
        this.login();
      }
    },
    login() {
      this.errors = [];
      var bodyFormData = new FormData();

      bodyFormData.append("", {
        username: this.username,
        password: this.password,
      });

      HTTP.post(
        BASE_URL + `user/login/`,

        {
          username: this.username,
          password: Aes.encrypt(
            this.password,
            this.username.toUpperCase() + "isigirijibun"
          ),
        }
      )
        .then((response) => {
          let data = response.data;
          if (data[0].success) {
            this.user = data[0];
            if (this.user.isActive) {
              if (this.user.isAdmin) {
                localStorage.user = Encrypt(JSON.stringify(this.user));
                this.$router.push("/");
              } else {
                this.errors.push("Users not allowd to login");
              }
            } else this.errors.push("User not active");
          } else {
            
            this.errors.push(data[0].message);
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  beforeMount() {
    localStorage.user = "";
    let dark = JSON.pars(Decrypt(localStorage.dark));
    this.$vuetify.theme.dark = dark;
  },
};
</script>
